import React, { useEffect } from "react";

import {
  useAddOrUpdateDigitalAgronomistPreferences,
  useCancelAsyncOnUnmount,
  useGetDigitalAgronomistPreferences,
  useNavigate,
  useTranslation,
  useUserContext,
} from "utils";

import { Flex, MainPage } from "components";

import Onboarding from "pages/app/digital-agronomist/components/Onboarding";

export const DigitalAgronomistOnboardingPage = () => {
  const { t } = useTranslation("digitalAgronomist");
  const { user } = useUserContext();
  const signal = useCancelAsyncOnUnmount()();
  const navigate = useNavigate();

  const { data, isPending } = useGetDigitalAgronomistPreferences({ user });
  const { mutate: addOrUpdateDigitalAgronomistPreferences } = useAddOrUpdateDigitalAgronomistPreferences();

  const mainCropsPreferencesCompleted = Object.entries(data || {})?.length > 0 && data?.cropRecommendations?.length === data?.preferences?.mainCropsNumber;

  useEffect(() => {
    if (mainCropsPreferencesCompleted) navigate("/side-crop-recommender");
  }, [mainCropsPreferencesCompleted, navigate]);

  useEffect(() => {
    if (!data && !isPending) addOrUpdateDigitalAgronomistPreferences({ requestBody: { mainCropsPreferences: [], settingsPreferences: {} }, signal });
  }, [addOrUpdateDigitalAgronomistPreferences, data, isPending, signal]);

  return (
    <MainPage
      fullWidth
      pageName="digital-agronomist-onboarding-page"
      loading={isPending || mainCropsPreferencesCompleted}
      share={{ title: t("digitalAgronomist") }}
      showMobileAlert
    >
      <div className="digital-agronomist">
        <Flex align="center" justify="center" style={{ flex: 1, overflow: "auto" }}>
          <Onboarding data={data!} />
        </Flex>
      </div>
    </MainPage>
  );
};
